export const columnConfig = [
  {
    cc: "bpp",
    cp: 1,
    hd: "BPP",
    v: true,
    cla: "left",
    scc: "bpp",
  },
  {
    cc: "plnt",
    cp: 2,
    hd: "Plant",
    v: true,
    cla: "left",
    scc: "plnt",
  },
  {
    cc: "order_id",
    cp: 3,
    hd: "Order Id",
    v: true,
    cla: "left",
    scc: "order_id",
  },
  {
    cc: "order_type",
    cp: 4,
    hd: "Order Type",
    v: true,
    cla: "left",
    scc: "order_type",
  },
  {
    cc: "line_item_id",
    cp: 5,
    hd: "Line Item Id",
    v: true,
    cla: "left",
    scc: "line_item_id",
  },
  {
    cc: "item_code",
    cp: 6,
    hd: "Item Code",
    v: true,
    cla: "left",
    scc: "item_code",
  },
  {
    cc: "item_desc",
    cp: 7,
    hd: "Item Description",
    v: true,
    cla: "left",
    scc: "item_desc",
  },
  {
    cc: "order_quantity",
    cp: 8,
    hd: "Order Quantity",
    v: true,
    cla: "left",
    scc: "order_quantity",
  },
  {
    cc: "trail_dept",
    cp: 9,
    hd: "Trailing Department",
    v: true,
    cla: "left",
    scc: "trail_dept",
  },
  {
    cc: "qty_mfg",
    cp: 10,
    hd: "Quantity Balance To Manufacture",
    v: true,
    cla: "left",
    scc: "qty_mfg",
  },
  {
    cc: "qty_disp",
    cp: 10,
    hd: "Quantity Balance To Dispatch",
    v: true,
    cla: "left",
    scc: "qty_disp",
  },
  {
    cc: "cus_code",
    cp: 11,
    hd: "Customer Code",
    v: true,
    cla: "left",
    scc: "cus_code",
  },
  {
    cc: "cus_name",
    cp: 12,
    hd: "Customer Name",
    v: true,
    cla: "left",
    scc: "cus_name",
  },
];

export const columnConfigData = {
  tableColumn: [
    {
      cc: "trailDept",
      cp: 1,
      hd: "Trailing Department",
      v: true,
      cla: "left",
      scc: "trailDept",
    },
    {
      cc: "b",
      cp: 2,
      hd: "Black",
      v: true,
      cla: "left",
      scc: "b",
    },
    {
      cc: "r",
      cp: 3,
      hd: "Red",
      v: true,
      cla: "left",
      scc: "r",
    },
    {
      cc: "y",
      cp: 4,
      hd: "Yellow",
      v: true,
      cla: "left",
      scc: "y",
    },
    {
      cc: "g",
      cp: 5,
      hd: "Green",
      v: true,
      cla: "left",
      scc: "g",
    },
    {
      cc: "bl",
      cp: 6,
      hd: "Blue",
      v: true,
      cla: "left",
      scc: "bl",
    },
    {
      cc: "w",
      cp: 6,
      hd: "White",
      v: true,
      cla: "left",
      scc: "w",
    },
  ],
};

export const APIMock = {
  data: {
    data: {
      tdept_ord_cnt: {
        "Cutting":
        {
          Black: 20,
          Red: 10,
          Yellow: 14,
          Green: 10,
          Blue: 9,
        },
        "Sewing":
        {
          Black: 22,
          Red: 9,
          Yellow: 14,
          Green: 10,
          Blue: 9,
        },
        "Embroidery":
        {
          Black: 18,
          Red: 13,
          Yellow: 14,
          Green: 10,
          Blue: 9,
        },
        "Finishing":
        {
          Black: 10,
          Red: 10,
          Yellow: 11,
          Green: 10,
          Blue: 9,
        },
        "Packing":
        {
          Black: 15,
          Red: 10,
          Yellow: 11,
          Green: 10,
          Blue: 9,
        },
      },
      mfg: {
        "Cutting":
        {
          Black: 20,
          Red: 10,
          Yellow: 14,
          Green: 0,
          Blue: 9,
        },
        "Sewing":
        {
          Black: 22,
          Red: 9,
          Yellow: 4,
          Green: 10,
          Blue: 9,
        },
        "Embroidery":
        {
          Black: 8,
          Red: 13,
          Yellow: 14,
          Green: 7,
          Blue: 9,
        },
        "Finishing":
        {
          Black: 10,
          Red: 21,
          Yellow: 11,
          Green: 10,
          Blue: 9,
        },
        "Packing":
        {
          Black: 15,
          Red: 2,
          Yellow: 1,
          Green: 10,
          Blue: 9,
        },
      },
      balDisp: [
        {
          trailDept: "Cutting",
          Black: 20,
          Red: 10,
          Yellow: 14,
          Green: 10,
          Blue: 9,
        },
        {
          trailDept: "Sewing",
          Black: 22,
          Red: 9,
          Yellow: 14,
          Green: 10,
          Blue: 9,
        },
        {
          trailDept: "Embroidery",
          Black: 18,
          Red: 13,
          Yellow: 14,
          Green: 10,
          Blue: 9,
        },
        {
          trailDept: "Finishing",
          Black: 10,
          Red: 10,
          Yellow: 11,
          Green: 10,
          Blue: 9,
        },
        {
          trailDept: "Packing",
          Black: 15,
          Red: 10,
          Yellow: 11,
          Green: 10,
          Blue: 9,
        },
      ],
      count: 7,
      results: [
        {
          bpp: 100,
          plnt: "A",
          order_id: "123",
          order_type: "abc",
          line_item_id: "321",
          item_code: "a",
          item_desc: "desc",
          order_quantity: 120,
          trail_dept: "packing",
          qty_mfg: 100,
          qty_disp: 80,
          cus_code: 101,
          cus_name: "Zara",
        },
        {
          bpp: 120,
          plnt: "A",
          order_id: "123",
          order_type: "abc",
          line_item_id: "321",
          item_code: "a",
          item_desc: "desc",
          order_quantity: 120,
          trail_dept: "packing",
          qty_mfg: 100,
          qty_disp: 80,
          cus_code: 101,
          cus_name: "Zara",
        },
        {
          bpp: 60,
          plnt: "A",
          order_id: "123",
          order_type: "abc",
          line_item_id: "321",
          item_code: "a",
          item_desc: "desc",
          order_quantity: 120,
          trail_dept: "packing",
          qty_mfg: 100,
          qty_disp: 80,
          cus_code: 101,
          cus_name: "Zara",
        },
        {
          bpp: 10,
          plnt: "A",
          order_id: "123",
          order_type: "abc",
          line_item_id: "321",
          item_code: "a",
          item_desc: "desc",
          order_quantity: 120,
          trail_dept: "packing",
          qty_mfg: 100,
          qty_disp: 80,
          cus_code: 101,
          cus_name: "Zara",
        },
        {
          bpp: 100,
          plnt: "A",
          order_id: "123",
          order_type: "abc",
          line_item_id: "321",
          item_code: "a",
          item_desc: "desc",
          order_quantity: 120,
          trail_dept: "packing",
          qty_mfg: 100,
          qty_disp: 80,
          cus_code: 101,
          cus_name: "Zara",
        },
        {
          bpp: 40,
          plnt: "A",
          order_id: "123",
          order_type: "abc",
          line_item_id: "321",
          item_code: "a",
          item_desc: "desc",
          order_quantity: 120,
          trail_dept: "packing",
          qty_mfg: 100,
          qty_disp: 80,
          cus_code: 101,
          cus_name: "Zara",
        },
        {
          bpp: 20,
          plnt: "A",
          order_id: "123",
          order_type: "abc",
          line_item_id: "321",
          item_code: "a",
          item_desc: "desc",
          order_quantity: 120,
          trail_dept: "packing",
          qty_mfg: 100,
          qty_disp: 80,
          cus_code: 101,
          cus_name: "Zara",
        },
      ],
    }
  }
};
